import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { SharedModule } from './shared/shared.module';
import { BreadcrumbsComponent } from './layouts/admin/breadcrumbs/breadcrumbs.component';
import { TitleComponent } from './layouts/admin/title/title.component';
import { ScrollModule } from './scroll/scroll.module';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';

import { LoginService } from '../app/services/authentication/login/login.service';
import { CompanyService } from '../app/services/company-management/company-management';
import { UnitService } from '../app/services/unit-management/unit-management';
import { AppService } from '../app/services/app-management/app-management';
import { UserService } from '../app/services/user-management/user-management';
import { UsersService } from '../app/services/users-management/users-management';
import { NewsService } from '../app/services/news-management/news-management';
import { EventService } from '../app/services/event-management/event-management';
import { CategoryService } from '../app/services/category-management/category-management';
import { CloneService } from '../app/services/common/clone-object-management';
import { ModuleService } from '../app/services/module-management/module-management';
import { OfferService } from '../app/services/offer-management/offer-management';
import { ChecklistService } from '../app/services/checklist-management/checklist-management';
import { ContactService } from '../app/services/contact-management/contact-management';
import { NotificationService } from '../app/services/notification-management/notification-management';
import { CommonApiService } from '../app/services/common/common-api-management';
import { UnitUserCommonService } from '../app/services/common/unit-user.common.service';
import { FaqService } from '../app/services/faq-management/faq-management';
import { LinkService } from '../app/services/link-management/link-management';
import { FormService } from '../app/services/form-management/form-management';
import { ForgotPasswordService } from '../app/services/authentication/forgot-password/forgot-password.service';
import { AuthGuard } from './services/authentication/guards/auth-guard.service';
import { ApiService } from './services/authentication/guards/api.service';
import { JwtService } from './services/authentication/guards/jwt.service';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastyModule } from 'ng2-toasty';
import { ToastService } from './services/shared/toastservice';
import { AppSelectService } from './services/shared/appSelectService';
import { DashboardService } from './services/dashboard-management/dashboard-management';
import { FileUploadApiService } from '../app/services/common/file-upload-management';
import { MenuManagementService } from '../app/services/common/menu-managemen';
import { UserEventCommonService } from './services/common/user-event.common.service';
import { GdprService } from './services/gdrp-management/gdrp-management';
import { AgreementService } from './services/agreement-management/agreement-management';
import { ItemLikeService } from './services/like-management/link-management';
import { UserProfileImageService } from './services/shared/userProfileImageService';
import { PrivacyService } from './services/privacy-management/privacy-management';
import { ResetService } from './services/reset-management/reset-management';
import { SMSStatisticsService } from './services/smsstatistics-management/smsstatistics-management';
import { SettingsService } from './services/settings-management/settings-management';
import { WebsiteService } from './services/website-management/website-management';
import { FestivalThemeService } from './services/festival-theme-management/festival-theme-management';
import { ErrorReportingService } from './services/error-reporting-management/error-reporting-management';

// import { translateCulturePipe } from './pipes/translate-culture-pipe'

// import { HTTP_INTERCEPTORS } from '@angular/common/http';
// import { HttpInterceptorUnauthorized } from './services/authentication/guards/httpInterceptorUnauthorized';

// import { dateCulturePipe } from './pipes/date-culture-pipe'
// import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    BreadcrumbsComponent,
    // translateCulturePipe,
    TitleComponent
  ],
  imports: [

    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),

    BrowserAnimationsModule,
    SharedModule,
    RouterModule.forRoot(AppRoutes),
    FormsModule,
    HttpModule,
    ScrollModule,
    ToastyModule.forRoot()
  ],
  exports: [ScrollModule, ToastyModule],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: HttpInterceptorUnauthorized,
    //   multi: true
    // },
    LoginService, ForgotPasswordService, AuthGuard, ApiService, JwtService, CompanyService,
    UnitService, AppService, UserService, UsersService, CategoryService, NewsService, EventService,
    ToastService, AppSelectService, FaqService, LinkService, FormService, CloneService, UserProfileImageService,
    ModuleService, OfferService, ChecklistService, ContactService, NotificationService, CommonApiService,
    DashboardService, FileUploadApiService, MenuManagementService, UnitUserCommonService, UserEventCommonService,
    GdprService, AgreementService, ItemLikeService, PrivacyService, ResetService, SMSStatisticsService,
    SettingsService, WebsiteService, FestivalThemeService, ErrorReportingService
  ],

  bootstrap: [AppComponent]
})

export class AppModule {
  constructor() { }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/app.module.ts